import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { HotelResultsFacade } from '@hotels/hotel-results/hotel-results.facade';
import { SelectedHotelFiltersContainer } from '@shared/magic-filter-bar/selected-hotel-filters/selected-hotel-filters.container';
import { MemberRateTagModule } from '@ux/components/member-rate-tag/member-rate-tag.module';
import { HotelFilterBarService } from '@shared/magic-filter-bar/hotel-filter-bar/services/hotel-filter-bar.service';
import { FilterBarTagModule } from '@shared/magic-filter-bar/filter-bar-tag/filter-bar-tag.module';
import { SelectedFiltersContModule } from '@shared/magic-filter-bar/selected-filters-cont/selected-filters-cont.module';

@NgModule({
  declarations: [
    SelectedHotelFiltersContainer
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    MemberRateTagModule,
    FilterBarTagModule,
    SelectedFiltersContModule,
  ],
  providers: [
    HotelResultsFacade,
    HotelFilterBarService,
  ],
  exports: [
    SelectedHotelFiltersContainer
  ]
})
export class SelectedHotelFiltersModule { }
